import React from "react";
import { YesNoField } from "../../../assets";
import OpeningTimes from "../../../components/Account/OpeningTimes";

export default function CollectionSection({ values, onChange }) {

	return <>
		<div className="details">
			Do you allow customers to collect products or services from your address? Click either 'yes' or 'no'.
		</div>
		<YesNoField
			value={values.acceptCollection}
			onChange={acceptCollection => onChange({ acceptCollection })}
		/>
		<br /><br />
		{values.acceptCollection === true && <>
			<div className="details">
				Great, what times do you offer collection? This allows customers to choose a certain time within these hours, but don't worry! You will always have control of accepting, rejecting or amending their requests.
				<br /><br />
				Add opening hours by selecting a day, from time and to time, then pressing the 'add' button.
				<br /><br />
				You can add as many as you want.
			</div>
			<OpeningTimes
				values={values.collectionTimes || []}
				change={collectionTimes => onChange({ collectionTimes })}
			/>
			<br /><br />
		</>}
		{values.acceptCollection === false && (
			<div className="details">
				OK, we don't need anything else.
			</div>
		)}
	</>
}